export default __webpack_public_path__ + "static/media/Medium's Hood of Secret Doors.65cd6b79.jpg";